import { useCustomUpdateProposalEstimatingMethodMutation } from "generated/graphql";
import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProposalEstimatingMethod() {
  const [mutation, { loading, data, error }] = useCustomUpdateProposalEstimatingMethodMutation({
    refetchQueries: ["getProposal", "customGetProposal"],
    awaitRefetchQueries: true,
  });
  const [updateProposalEstimatingMethod, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProposalEstimatingMethod",
    },
    {
      successMessage: getLocalString("worksheet.update-estimating-method-success"),
      failureMessage: getLocalString("worksheet.update-estimating-method-failure"),
      showValidationErrors: true,
    }
  );

  return [updateProposalEstimatingMethod, context] as const;
}
